import {Feature, Features} from "../feature";


export const amineFilter = {
    isAmine: (name: string) => name.includes(Features.amine),
    isAmide: (name: string) => name.includes(Features.amide),
    filterInPlace: (features: Feature[]) => {
        // If amine is part of amide, then only report the amide.
        const amines = features.filter(f => amineFilter.isAmine(f.name));
        const amides = features.filter(f => amineFilter.isAmide(f.name));
        const partsOfAmides = amines.filter(amine => amides.some(amide => amide.atoms.includes(amine.atoms[0])));
        partsOfAmides.forEach(amine => features.splice(features.indexOf(amine), 1));
    }
}